export const STORYBOARD_TYPES = {
  INTERACTIVE_CONTENT: "INTERACTIVE_CONTENT",
  INTERACTIVE_CONTENT_V2: "INTERACTIVE_CONTENT_V2",
  LANDING_PAGE: "LANDING_PAGE",
  RESOURCE_CENTER: "RESOURCE_CENTER",
  SPATIAL: "SPATIAL",
  FLIP_BOOK: 'FLIP_BOOK'
}

export const INTERACTIVE_CONTENT_TYPES = [
  STORYBOARD_TYPES.INTERACTIVE_CONTENT,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]

/* Will render muiltple pages in the live url */
export const MULTIPAGE_STORYBOARDS = [
  STORYBOARD_TYPES.SPATIAL,
  STORYBOARD_TYPES.FLIP_BOOK,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]

/* SEGMENT STORYBOARD TYPE */
export const SEGMENT_STORYBOARDS = [
  STORYBOARD_TYPES.LANDING_PAGE,
  STORYBOARD_TYPES.RESOURCE_CENTER,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]

/* storyboards which can't strech the whole window size */
export const PAGE_CONTAIN_STORYBOARDS = [
  STORYBOARD_TYPES.SPATIAL,
  STORYBOARD_TYPES.FLIP_BOOK,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2
]

export const MULTIPAGE_SEEK_INDEXING_STORYBOARDS = [
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2,
]

export const PPT_SUPPORTED_STORYBOARDS = [
  ...INTERACTIVE_CONTENT_TYPES,
  STORYBOARD_TYPES.SPATIAL,
]

export const FIGMA_SUPPORTED_STORYBOARDS = [
  ...INTERACTIVE_CONTENT_TYPES,
  STORYBOARD_TYPES.LANDING_PAGE,
  STORYBOARD_TYPES.RESOURCE_CENTER,
]

export const SLIDE_STORYBOARDS = [
  STORYBOARD_TYPES.SPATIAL,
  STORYBOARD_TYPES.FLIP_BOOK
]

export const FRAMELESS_EDITOR_ENTITY_TYPES = [
  'GATING',
  'LIVE_ELEMENT',
  'PALETTE_COMPONENT',
];

export const supportsFrameEditorFeatures = (entityType, storyboardType) =>
  SEGMENT_STORYBOARDS.includes(storyboardType) &&
  !FRAMELESS_EDITOR_ENTITY_TYPES.includes(entityType);